(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguebig/assets/javascripts/models/league-big-statistics-model.js') >= 0) return;  svs.modules.push('/components/statistics/leaguebig/assets/javascripts/models/league-big-statistics-model.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.models = svs.statistics.big.models || {};

  svs.statistics.big.models.LeagueBigStatisticsModel = Backbone.Model.extend({
    url: function() {
      return svs.core.jupiter.url() + '/sport/1/leagues/' + this.get('leagueId');
    },
    initialize: function() {
      if (this.get('leagueId')) {
        this.fetch();
      }
    },
    parse: function(response) {
      if (response.league) {
        if (response.league.underlyingLeagues) {
          response.league.underlyingLeagues = _.filter(
            response.league.underlyingLeagues,
            function(league) {
              return league.rank > -1;
            }
          );
          response.league.underlyingLeagues = _.sortBy(
            response.league.underlyingLeagues,
            function(league) {
              return league.name;
            }
          );
          response.league.underlyingLeagues = _.sortBy(
            response.league.underlyingLeagues,
            function(league) {
              if (league.rank === 0) {
                return 1000000;
              }
              return league.rank;
            }
          );
        }
      }
      return response;
    },
    close: function() {},
    dispose: function() {}
  });
})(Backbone, _, svs);

 })(window);